/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 148);
/******/ })
/************************************************************************/
/******/ ({

/***/ 110:
/***/ (function(module, exports) {

module.exports = THREE;

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_fs__ = __webpack_require__(149);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ImprovedNoise", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FirstPersonControls", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "worldWidth", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "worldDepth", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "worldHalfWidth", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "worldHalfDepth", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clock", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "generateHeight", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "generateTexture", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "init", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scene", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "renderer", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "controls", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "camera", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "render", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "animate", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["c"]; });


/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ImprovedNoise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FirstPersonControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return worldWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return worldDepth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return worldHalfWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return worldHalfDepth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clock; });
/* harmony export (immutable) */ __webpack_exports__["g"] = generateHeight;
/* harmony export (immutable) */ __webpack_exports__["h"] = generateTexture;
/* harmony export (immutable) */ __webpack_exports__["i"] = init;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return scene; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return renderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return controls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return camera; });
/* harmony export (immutable) */ __webpack_exports__["j"] = render;
/* harmony export (immutable) */ __webpack_exports__["c"] = animate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_ImprovedNoise_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_FirstPersonControls_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_three__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_three___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_three__);




var ImprovedNoise = __WEBPACK_IMPORTED_MODULE_0__lib_ImprovedNoise_js__["a" /* default */];
var FirstPersonControls = __WEBPACK_IMPORTED_MODULE_1__lib_FirstPersonControls_js__["a" /* default */];
var worldWidth = 256;
var worldDepth = 256;
var worldHalfWidth = ~~(worldWidth / 2);
var worldHalfDepth = ~~(worldDepth / 2);
var clock = new __WEBPACK_IMPORTED_MODULE_2_three__["Clock"]();
function generateHeight(width, height) {
    var size = width * height | 0;
    var data = new Float64Array(size);
    var perlin = ImprovedNoise();
    var quality = 1;
    var z = Math.random() * 100;

    for (var j = 0; j <= 3; j++) {
        for (var i = 0; i <= size - 1; i++) {
            var x = i % width | 0;
            var y = ~~(i / width) | 0;
            var noise = perlin.noise(x / quality, y / quality, z) * quality * 1.75;
            data[i] = data[i] + Math.abs(noise);
        }

        quality = quality * 5;
    }

    return data;
}
function generateTexture(data, width, height) {
    var vector3 = new __WEBPACK_IMPORTED_MODULE_2_three__["Vector3"](0, 0, 0);
    var sun = new __WEBPACK_IMPORTED_MODULE_2_three__["Vector3"](1, 1, 1).normalize();
    var canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    var context = canvas.getContext("2d");
    context.fillStyle = "#000";
    context.fillRect(0, 0, width, height);
    var image = context.getImageData(0, 0, canvas.width, canvas.height);
    var imageData = image.data;
    var i = 0;
    var j = 0;
    var l = ~~imageData.length | 0;

    while (i < l) {
        vector3.x = data[j - 2] - data[j + 2];
        vector3.y = 2;
        vector3.z = data[j - width * 2] - data[j + width * 2];
        vector3.normalize();
        var shade = vector3.dot(sun);
        imageData[i] = (96 + shade * 128) * (0.5 + data[j] * 0.007);
        imageData[i + 1] = (32 + shade * 96) * (0.5 + data[j] * 0.007);
        imageData[i + 2] = shade * 96 * (0.5 + data[j] * 0.007);
        i = i + 4 | 0;
        j = j + 1 | 0;
    }

    context.putImageData(image, 0, 0);
    var canvasScaled = document.createElement("canvas");
    canvasScaled.width = width * 4;
    canvasScaled.height = height * 4;
    var context_1 = canvasScaled.getContext("2d");
    context_1.scale(4, 4);
    context_1.drawImage(canvas, 0, 0);
    var image_1 = context_1.getImageData(0, 0, canvasScaled.width, canvasScaled.height);
    var imageData_1 = image_1.data;
    var i_1 = 0;
    var l_1 = ~~imageData_1.length | 0;

    while (i_1 < l_1) {
        var v = ~~~~(Math.random() * 5);
        imageData_1[i_1] = imageData_1[i_1] + v;
        imageData_1[i_1 + 1] = imageData_1[i_1 + 1] + v;
        imageData_1[i_1 + 2] = imageData_1[i_1 + 2] + v;
        i_1 = i_1 + 4 | 0;
    }

    context_1.putImageData(image_1, 0, 0);
    return canvasScaled;
}
function init() {
    var getWidth = function getWidth() {
        return window.innerWidth;
    };

    var getHeight = function getHeight() {
        return window.innerHeight;
    };

    var container = document.getElementById("container");
    var camera = new __WEBPACK_IMPORTED_MODULE_2_three__["PerspectiveCamera"](60, getWidth() / getHeight(), 1, 20000);
    var scene = new __WEBPACK_IMPORTED_MODULE_2_three__["Scene"]();
    var renderer = new __WEBPACK_IMPORTED_MODULE_2_three__["WebGLRenderer"]();
    renderer.setClearColor("#bfd1e5");
    renderer.setSize(getWidth(), getHeight());
    var domElement = renderer.domElement;
    container.innerHTML = "";
    container.appendChild(domElement);
    var controls = new FirstPersonControls(camera, domElement);
    controls.movementSpeed = 1000;
    controls.lookSpeed = 0.1;
    var data = generateHeight(worldWidth, worldDepth);
    camera.position.y = data[worldHalfWidth + worldHalfDepth * worldWidth] * 10 + 500;
    var geometry = new __WEBPACK_IMPORTED_MODULE_2_three__["PlaneBufferGeometry"](7500, 7500, worldWidth - 1, worldDepth - 1);
    geometry.applyMatrix(new __WEBPACK_IMPORTED_MODULE_2_three__["Matrix4"]().makeRotationX(-Math.PI / 2));
    var vertices = geometry.getAttribute("position");
    var vertices_1 = vertices.array;
    var l = ~~vertices_1.length | 0;
    var i = 0;
    var j = 0;

    while (i < l) {
        vertices_1[j + 1] = data[i] * 10;
        i = i + 1 | 0;
        j = j + 3 | 0;
    }

    var texCanvas = generateTexture(data, worldWidth, worldDepth);
    var texture = new __WEBPACK_IMPORTED_MODULE_2_three__["Texture"](texCanvas, __WEBPACK_IMPORTED_MODULE_2_three__["UVMapping"], __WEBPACK_IMPORTED_MODULE_2_three__["ClampToEdgeWrapping"], __WEBPACK_IMPORTED_MODULE_2_three__["ClampToEdgeWrapping"]);
    texture.needsUpdate = true;
    var matProps = {};
    matProps.map = texture;
    var mesh = new __WEBPACK_IMPORTED_MODULE_2_three__["Mesh"](geometry, new __WEBPACK_IMPORTED_MODULE_2_three__["MeshBasicMaterial"](matProps));
    scene.add(mesh);

    var onWindowResize = function onWindowResize(e) {
        camera.aspect = getWidth() / getHeight();
        camera.updateProjectionMatrix();
        renderer.setSize(getWidth(), getHeight());
        controls.handleResize();
        return null;
    };

    window.addEventListener("resize", function (delegateArg0) {
        return onWindowResize(delegateArg0);
    }, false);
    return [renderer, scene, camera, controls];
}
var patternInput_255_3 = init();
var scene = patternInput_255_3[1];
var renderer = patternInput_255_3[0];
var controls = patternInput_255_3[3];
var camera = patternInput_255_3[2];
function render() {
    controls.update(clock.getDelta());
    renderer.render(scene, camera);
}
function animate(dt) {
    window.requestAnimationFrame(function (delegateArg0) {
        animate(delegateArg0);
    });
    render();
}
animate(0);

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ImprovedNoise;
// http://mrl.nyu.edu/~perlin/noise/

function ImprovedNoise() {

	var p = [151, 160, 137, 91, 90, 15, 131, 13, 201, 95, 96, 53, 194, 233, 7, 225, 140, 36, 103, 30, 69, 142, 8, 99, 37, 240, 21, 10, 23, 190, 6, 148, 247, 120, 234, 75, 0, 26, 197, 62, 94, 252, 219, 203, 117, 35, 11, 32, 57, 177, 33, 88, 237, 149, 56, 87, 174, 20, 125, 136, 171, 168, 68, 175, 74, 165, 71, 134, 139, 48, 27, 166, 77, 146, 158, 231, 83, 111, 229, 122, 60, 211, 133, 230, 220, 105, 92, 41, 55, 46, 245, 40, 244, 102, 143, 54, 65, 25, 63, 161, 1, 216, 80, 73, 209, 76, 132, 187, 208, 89, 18, 169, 200, 196, 135, 130, 116, 188, 159, 86, 164, 100, 109, 198, 173, 186, 3, 64, 52, 217, 226, 250, 124, 123, 5, 202, 38, 147, 118, 126, 255, 82, 85, 212, 207, 206, 59, 227, 47, 16, 58, 17, 182, 189, 28, 42, 223, 183, 170, 213, 119, 248, 152, 2, 44, 154, 163, 70, 221, 153, 101, 155, 167, 43, 172, 9, 129, 22, 39, 253, 19, 98, 108, 110, 79, 113, 224, 232, 178, 185, 112, 104, 218, 246, 97, 228, 251, 34, 242, 193, 238, 210, 144, 12, 191, 179, 162, 241, 81, 51, 145, 235, 249, 14, 239, 107, 49, 192, 214, 31, 181, 199, 106, 157, 184, 84, 204, 176, 115, 121, 50, 45, 127, 4, 150, 254, 138, 236, 205, 93, 222, 114, 67, 29, 24, 72, 243, 141, 128, 195, 78, 66, 215, 61, 156, 180];

	for (var i = 0; i < 256; i++) {

		p[256 + i] = p[i];
	}

	function fade(t) {

		return t * t * t * (t * (t * 6 - 15) + 10);
	}

	function lerp(t, a, b) {

		return a + t * (b - a);
	}

	function grad(hash, x, y, z) {

		var h = hash & 15;
		var u = h < 8 ? x : y,
		    v = h < 4 ? y : h == 12 || h == 14 ? x : z;
		return ((h & 1) == 0 ? u : -u) + ((h & 2) == 0 ? v : -v);
	}

	return {

		noise: function noise(x, y, z) {

			var floorX = ~~x,
			    floorY = ~~y,
			    floorZ = ~~z;

			var X = floorX & 255,
			    Y = floorY & 255,
			    Z = floorZ & 255;

			x -= floorX;
			y -= floorY;
			z -= floorZ;

			var xMinus1 = x - 1,
			    yMinus1 = y - 1,
			    zMinus1 = z - 1;

			var u = fade(x),
			    v = fade(y),
			    w = fade(z);

			var A = p[X] + Y,
			    AA = p[A] + Z,
			    AB = p[A + 1] + Z,
			    B = p[X + 1] + Y,
			    BA = p[B] + Z,
			    BB = p[B + 1] + Z;

			return lerp(w, lerp(v, lerp(u, grad(p[AA], x, y, z), grad(p[BA], xMinus1, y, z)), lerp(u, grad(p[AB], x, yMinus1, z), grad(p[BB], xMinus1, yMinus1, z))), lerp(v, lerp(u, grad(p[AA + 1], x, y, zMinus1), grad(p[BA + 1], xMinus1, y, z - 1)), lerp(u, grad(p[AB + 1], x, yMinus1, zMinus1), grad(p[BB + 1], xMinus1, yMinus1, zMinus1))));
		}
	};
}

/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FirstPersonControls;
/**
 * @author mrdoob / http://mrdoob.com/
 * @author alteredq / http://alteredqualia.com/
 * @author paulirish / http://paulirish.com/
 */

function FirstPersonControls(object, domElement) {
	function getOffsetRect(elem) {
		var box = elem.getBoundingClientRect();
		var body = document.body;
		var docElem = document.documentElement;
		var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
		var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
		var clientTop = docElem.clientTop || body.clientTop || 0;
		var clientLeft = docElem.clientLeft || body.clientLeft || 0;
		var top = box.top + scrollTop - clientTop;
		var left = box.left + scrollLeft - clientLeft;
		return { top: Math.round(top), left: Math.round(left) };
	}

	this.object = object;
	this.target = new THREE.Vector3(0, 0, 0);

	this.domElement = domElement !== undefined ? domElement : document;

	this.movementSpeed = 1.0;
	this.lookSpeed = 0.005;

	this.lookVertical = true;
	this.autoForward = false;
	// this.invertVertical = false;

	this.activeLook = true;

	this.heightSpeed = false;
	this.heightCoef = 1.0;
	this.heightMin = 0.0;
	this.heightMax = 1.0;

	this.constrainVertical = false;
	this.verticalMin = 0;
	this.verticalMax = Math.PI;

	this.autoSpeedFactor = 0.0;

	this.mouseX = 0;
	this.mouseY = 0;

	this.lat = 0;
	this.lon = 0;
	this.phi = 0;
	this.theta = 0;

	this.moveForward = false;
	this.moveBackward = false;
	this.moveLeft = false;
	this.moveRight = false;
	this.freeze = false;

	this.mouseDragOn = false;

	this.viewHalfX = 0;
	this.viewHalfY = 0;

	if (this.domElement !== document) {

		this.domElement.setAttribute("tabindex", -1);
	}

	//

	this.handleResize = function () {

		if (this.domElement === document) {

			this.viewHalfX = window.innerWidth / 2;
			this.viewHalfY = window.innerHeight / 2;
		} else {

			this.viewHalfX = this.domElement.offsetWidth / 2;
			this.viewHalfY = this.domElement.offsetHeight / 2;
		}
	};

	this.onMouseDown = function (event) {

		if (this.domElement !== document) {

			this.domElement.focus();
		}

		event.preventDefault();
		event.stopPropagation();

		if (this.activeLook) {

			switch (event.button) {

				case 0:
					this.moveForward = true;break;
				case 2:
					this.moveBackward = true;break;

			}
		}

		this.mouseDragOn = true;
	};

	this.onMouseUp = function (event) {

		event.preventDefault();
		event.stopPropagation();

		if (this.activeLook) {

			switch (event.button) {

				case 0:
					this.moveForward = false;break;
				case 2:
					this.moveBackward = false;break;

			}
		}

		this.mouseDragOn = false;
	};

	this.onMouseMove = function (event) {

		if (this.domElement === document) {

			this.mouseX = event.pageX - this.viewHalfX;
			this.mouseY = event.pageY - this.viewHalfY;
		} else {
			var rect = getOffsetRect(this.domElement);

			this.mouseX = event.pageX - rect.left - this.viewHalfX;
			this.mouseY = event.pageY - rect.top - this.viewHalfY;
		}
	};

	this.onKeyDown = function (event) {

		//event.preventDefault();

		switch (event.keyCode) {

			case 38: /*up*/
			case 87:
				/*W*/this.moveForward = true;break;

			case 37: /*left*/
			case 65:
				/*A*/this.moveLeft = true;break;

			case 40: /*down*/
			case 83:
				/*S*/this.moveBackward = true;break;

			case 39: /*right*/
			case 68:
				/*D*/this.moveRight = true;break;

			case 82:
				/*R*/this.moveUp = true;break;
			case 70:
				/*F*/this.moveDown = true;break;

			case 81:
				/*Q*/this.freeze = !this.freeze;break;

		}
	};

	this.onKeyUp = function (event) {

		switch (event.keyCode) {

			case 38: /*up*/
			case 87:
				/*W*/this.moveForward = false;break;

			case 37: /*left*/
			case 65:
				/*A*/this.moveLeft = false;break;

			case 40: /*down*/
			case 83:
				/*S*/this.moveBackward = false;break;

			case 39: /*right*/
			case 68:
				/*D*/this.moveRight = false;break;

			case 82:
				/*R*/this.moveUp = false;break;
			case 70:
				/*F*/this.moveDown = false;break;

		}
	};

	this.update = function (delta) {

		if (this.freeze) {

			return;
		}

		if (this.heightSpeed) {

			var y = THREE.Math.clamp(this.object.position.y, this.heightMin, this.heightMax);
			var heightDelta = y - this.heightMin;

			this.autoSpeedFactor = delta * (heightDelta * this.heightCoef);
		} else {

			this.autoSpeedFactor = 0.0;
		}

		var actualMoveSpeed = delta * this.movementSpeed;

		if (this.moveForward || this.autoForward && !this.moveBackward) this.object.translateZ(-(actualMoveSpeed + this.autoSpeedFactor));
		if (this.moveBackward) this.object.translateZ(actualMoveSpeed);

		if (this.moveLeft) this.object.translateX(-actualMoveSpeed);
		if (this.moveRight) this.object.translateX(actualMoveSpeed);

		if (this.moveUp) this.object.translateY(actualMoveSpeed);
		if (this.moveDown) this.object.translateY(-actualMoveSpeed);

		var actualLookSpeed = delta * this.lookSpeed;

		if (!this.activeLook) {

			actualLookSpeed = 0;
		}

		var verticalLookRatio = 1;

		if (this.constrainVertical) {

			verticalLookRatio = Math.PI / (this.verticalMax - this.verticalMin);
		}

		this.lon += this.mouseX * actualLookSpeed;
		if (this.lookVertical) this.lat -= this.mouseY * actualLookSpeed * verticalLookRatio;

		this.lat = Math.max(-85, Math.min(85, this.lat));
		this.phi = THREE.Math.degToRad(90 - this.lat);

		this.theta = THREE.Math.degToRad(this.lon);

		if (this.constrainVertical) {

			this.phi = THREE.Math.mapLinear(this.phi, 0, Math.PI, this.verticalMin, this.verticalMax);
		}

		var targetPosition = this.target,
		    position = this.object.position;

		targetPosition.x = position.x + 100 * Math.sin(this.phi) * Math.cos(this.theta);
		targetPosition.y = position.y + 100 * Math.cos(this.phi);
		targetPosition.z = position.z + 100 * Math.sin(this.phi) * Math.sin(this.theta);

		this.object.lookAt(targetPosition);
	};

	this.domElement.addEventListener("contextmenu", function (event) {
		event.preventDefault();
	}, false);

	this.domElement.addEventListener("mousemove", bind(this, this.onMouseMove), false);
	this.domElement.addEventListener("mousedown", bind(this, this.onMouseDown), false);
	this.domElement.addEventListener("mouseup", bind(this, this.onMouseUp), false);

	window.addEventListener("keydown", bind(this, this.onKeyDown), false);
	window.addEventListener("keyup", bind(this, this.onKeyUp), false);

	function bind(scope, fn) {

		return function () {

			fn.apply(scope, arguments);
		};
	};

	this.handleResize();
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// webgl-terrain/bundle.js